import { asGradingId } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { FC } from "react";
import { useParams } from "react-router";
import { KnowledgeBaseAdherenceStatementSlideoverDialogContainer } from "./knowledgeBaseAdherenceStatementSlideoverDialogContainer.js";

export const TrainingTeammatePageKnowledgeBaseAdherenceStatement: FC = () => {
  const { gradingId: gradingIdParam, statementId } = useParams();
  if (!gradingIdParam || !statementId) {
    throw new Error("Missing params.");
  }
  const gradingId = asGradingId(gradingIdParam);

  return (
    <KnowledgeBaseAdherenceStatementSlideoverDialogContainer
      gradingId={gradingId}
      statementId={statementId}
    />
  );
};
